module.exports = __webpack_public_path__ + "img/ic-password-show.2aa0f31f.svg";